import React from 'react';
export function HowItWorksSection() {
  return <section className="s-dark fu" data-id="element-218">
      <div className="c relative z-10" data-id="element-219">
        <span className="slabel" data-id="element-220">El proceso</span>
        <h2 className="stitle" data-id="element-221">Así funciona.</h2>
        <div className="div-line" data-id="element-222"></div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-0 max-w-[880px] mx-auto mt-8 md:mt-[56px] relative" data-id="element-223">
          {/* Horizontal line for desktop */}
          <div className="hidden md:block absolute top-[24px] left-[10%] right-[10%] h-[1px] bg-[linear-gradient(90deg,transparent,rgba(201,169,110,0.35),rgba(201,169,110,0.35),transparent)] z-0" data-id="element-224" />

          <div className="flex flex-col items-center text-center px-2 md:px-3 relative z-10 group" data-id="element-225">
            <div className="w-12 h-12 md:w-12 md:h-12 rounded-full border-2 border-[var(--gold)] bg-[var(--bg)] flex items-center justify-center font-serif text-[clamp(1.3rem,4vw,1.6rem)] text-[rgba(212,184,150,0.15)] mb-3 md:mb-5 transition-all duration-300 group-hover:bg-[var(--gold)] group-hover:text-[var(--bg)]" data-id="element-226">
              1
            </div>
            <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 text-[var(--gold-l)] mb-1.5 md:mb-2" data-id="element-227">
              Elegís
            </h3>
            <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400" data-id="element-228">
              Identificás qué emoción o ciclo querés trabajar.{' '}
              <em className="text-[var(--nude)] italic" data-id="element-229">
                Tu intuición te guía al ritual que necesitás hoy.
              </em>
            </p>
          </div>

          <div className="flex flex-col items-center text-center px-2 md:px-3 relative z-10 group" data-id="element-230">
            <div className="w-12 h-12 md:w-12 md:h-12 rounded-full border-2 border-[var(--gold)] bg-[var(--bg)] flex items-center justify-center font-serif text-[clamp(1.3rem,4vw,1.6rem)] text-[rgba(212,184,150,0.15)] mb-3 md:mb-5 transition-all duration-300 group-hover:bg-[var(--gold)] group-hover:text-[var(--bg)]" data-id="element-231">
              2
            </div>
            <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 text-[var(--gold-l)] mb-1.5 md:mb-2" data-id="element-232">
              Preparás
            </h3>
            <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400" data-id="element-233">
              Creás el{' '}
              <strong className="text-white font-700" data-id="element-234">
                espacio físico y mental
              </strong>
              . Práctica breve de respiración para conectar con la emoción.
            </p>
          </div>

          <div className="flex flex-col items-center text-center px-2 md:px-3 relative z-10 group" data-id="element-235">
            <div className="w-12 h-12 md:w-12 md:h-12 rounded-full border-2 border-[var(--gold)] bg-[var(--bg)] flex items-center justify-center font-serif text-[clamp(1.3rem,4vw,1.6rem)] text-[rgba(212,184,150,0.15)] mb-3 md:mb-5 transition-all duration-300 group-hover:bg-[var(--gold)] group-hover:text-[var(--bg)]" data-id="element-236">
              3
            </div>
            <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 text-[var(--gold-l)] mb-1.5 md:mb-2" data-id="element-237">
              Ejecutás
            </h3>
            <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400" data-id="element-238">
              Seguís la guía paso a paso.{' '}
              <em className="text-[var(--nude)] italic" data-id="element-239">
                La magia está en la calidad de tu presencia, no en la velocidad.
              </em>
            </p>
          </div>

          <div className="flex flex-col items-center text-center px-2 md:px-3 relative z-10 group" data-id="element-240">
            <div className="w-12 h-12 md:w-12 md:h-12 rounded-full border-2 border-[var(--gold)] bg-[var(--bg)] flex items-center justify-center font-serif text-[clamp(1.3rem,4vw,1.6rem)] text-[rgba(212,184,150,0.15)] mb-3 md:mb-5 transition-all duration-300 group-hover:bg-[var(--gold)] group-hover:text-[var(--bg)]" data-id="element-241">
              4
            </div>
            <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 text-[var(--gold-l)] mb-1.5 md:mb-2" data-id="element-242">
              Integrás
            </h3>
            <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400" data-id="element-243">
              Registrás en el Diario lo que surgió y{' '}
              <strong className="text-[#E8C88A] font-700" data-id="element-244">
                cerrás el ciclo
              </strong>{' '}
              con consciencia plena.
            </p>
          </div>
        </div>
      </div>
    </section>;
}